import React, { CSSProperties, FC } from 'react';
import type { Rule } from 'antd/lib/form';
import { Link } from '../../../../../components/Element';
import { AppInfo } from '../../../../../constants';

export const TERMS_OF_USE_FIELD_KEY = 'termOfUse';

export const TERMS_REQUIRED_MESSAGE = 'Accept the Terms of Use and the Privacy Policy to continue.';

// A plain `required` rule accepts `false`, which is the value of a box that was
// ticked and then cleared. Only the boolean true is an acceptance (B-071).
export const termsOfUseRules: Rule[] = [
  {
    validator: (_rule, value) => (value === true ? Promise.resolve() : Promise.reject(new Error(TERMS_REQUIRED_MESSAGE))),
  },
];

type TermsOfUseLabelProps = {
  linkStyle?: CSSProperties;
};

export const TermsOfUseLabel: FC<TermsOfUseLabelProps> = ({ linkStyle }) => (
  <>
    I agree to{' '}
    <Link url={AppInfo.termsOfService} target="_blank" style={linkStyle}>
      Terms of Use
    </Link>{' '}
    and{' '}
    <Link url={AppInfo.privacyPolicy} target="_blank" style={linkStyle}>
      Privacy Policy
    </Link>
  </>
);

export default TermsOfUseLabel;
